import { render, staticRenderFns } from "./TabGlucose.vue?vue&type=template&id=53062c19&scoped=true&"
import script from "./TabGlucose.vue?vue&type=script&lang=js&"
export * from "./TabGlucose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53062c19",
  null
  
)

export default component.exports